<template>


    <b-card class="standardpage reports invoices border-none">
        <div class="availtable datatable">
            <b-card class="w-100pct">
                <!-- <b-overlay :show="busy" rounded="sm"> -->
                <b-card-body class="py-0 px-0">

                    <b-tabs class="gridtabs" v-model="tabindex">
                        <b-tab>
                            <template #title>
                                <div class="badgecontainer pr-3 mr-1">
                                    <i class="fa fa-link text-orange mr-2"></i>
                                    Match
                                    <b-badge id="selection" variant="primary" class="edit_tab">
                                        {{ referenceno.length }}</b-badge>
                                    <b-tooltip target="selection" placement="bottom">{{ referenceno.length }}
                                        transaction(s)
                                        selected</b-tooltip>
                                </div>

                            </template>
                            <p>


                                <b-row class="my-2">
                                    <b-col cols="12" sm="12" md="12" xl="12">
                                        <b-form-checkbox id="multiple" v-model="multiple" name="multiple" value="true"
                                            unchecked-value="false">
                                            Allow match over multiple SL A/C's
                                        </b-form-checkbox>
                                    </b-col>
                                </b-row>
                                <b-row class="my-2">
                                    <b-col cols="12" sm="12" md="12" xl="12">
                                        <b-form-group
                                            :label="'Transaction Ref ( Paste List ), Count [ ' + referenceno.length + ' ]'"
                                            label-for="referenceno" label-cols="12">
                                            <b-input-group class="z-0">
                                                <b-form-tags input-id="reflist" v-model="referenceno"
                                                    tag-variant="primary" separator=" ,;"
                                                    placeholder="Paste Ref (IV519826,CV519827,...)" size="sm"
                                                    class="h-29" add-button-text="+" add-on-change remove-on-delete
                                                    add-button-variant="outline-primary"></b-form-tags>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="referenceno = []">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                </b-row>

                                <b-row class="mt-2" v-if="item.message">
                                    <b-col>
                                        <b-alert :show="true" :variant="item.error ? 'danger' : 'success'">
                                            <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                                    <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                                                <b-col>
                                                    <span class="h6">
                                                        {{ item.message }}
                                                    </span>
                                                </b-col>
                                            </b-row>
                                        </b-alert>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label-cols="12" label="TransactionNo" label-size="sm">
                                            <b-input-group>
                                                <b-form-input v-model="item.transactionno" :debounce="matches.debounce"
                                                    placeholder="(auto)" :disabled="true"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.transactionno = ''" :disabled="true">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6">
                                        <b-form-group label-cols="12"
                                            :label="'Your Ref [ limit: 60, currently: ' + item.yourref.length + ' ]'"
                                            label-size="sm">
                                            <b-input-group>
                                                <b-form-input v-model="item.yourref" :debounce="matches.debounce"
                                                    placeholder="Your Ref"
                                                    :state="item.yourref.length <= 60 ? true : false"
                                                    :disabled="item.error || postit_disabled"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.yourref = ''"
                                                        :disabled="item.error || postit_disabled">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </p>
                            <b-row class="mt-2">
                                <b-col class="text-left" cols="auto">
                                    <b-button v-if="item.error" squared size="sm" variant="warning"
                                        @click="matches_load(0)" :disabled="referenceno.length == 0">
                                        <i class="fa fa-check"></i>
                                        Check It
                                    </b-button>

                                    <b-button v-if="!item.error" squared size="sm" variant="primary"
                                        @click="matches_save" :disabled="postit_disabled || item.yourref.length > 60">
                                        <i class="fa fa-check"></i>
                                        Post It
                                    </b-button>
                                </b-col>

                                <b-col class="text-left ml-2 mt-1">
                                    <div v-if="busy">
                                        <i class="fa fa-spinner fa-spin text-primary"></i>
                                    </div>
                                    <div v-else>
                                        <span v-html="message"></span>
                                    </div>
                                </b-col>
                            </b-row>


                        </b-tab>

                        <b-tab>
                            <template #title>
                                <div class="badgecontainer pr-2 mr-1">
                                    <i class="fa fa-table text-primary mr-1"></i>
                                    Transactions & Part Pay
                                </div>
                            </template>


                            <b-row>
                                <b-col>
                                    <b-alert :show="true" variant="secondary">
                                        <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                                <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                                            <b-col>
                                                <span class="h6"> Match transactions in the sales ledger,
                                                    select a list of transactions below
                                                    to zero the due amount.
                                                </span></b-col></b-row>
                                    </b-alert></b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="12" sm="6" md="4" xl="3">
                                    <b-form-group label-cols="12" label="Supplier SL A/C" label-size="sm">
                                        <treeselect placeholder="Select slac..."
                                            searchPromptText="Type at least 3 chars..." v-model="slac" :clearable="true"
                                            :async="true" :load-options="treeselect_loadSLAC" :show-count="true"
                                            :flatten-search-results="true" :disable-branch-nodes="true"
                                            :matchKeys="['id']" search-nested :disabled="false" :multiple="true">
                                            <div slot="value-label" slot-scope="{ node }">
                                                {{ node.raw.id }}
                                            </div>
                                        </treeselect>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" sm="6" md="4" xl="3">
                                    <b-form-group label-cols="12" label="Event" label-size="sm">
                                        <treeselect placeholder="Select event..."
                                            searchPromptText="Type at least 3 chars..." v-model="eventcode"
                                            :clearable="true" :async="true" :load-options="treeselect_loadEvent"
                                            :show-count="true" :flatten-search-results="true"
                                            :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                                            :disabled="false" :multiple="true">
                                            <div slot="value-label" slot-scope="{ node }">
                                                {{ node.raw.id }}
                                            </div>
                                        </treeselect>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" sm="6" md="4" xl="3">
                                    <b-form-group label="Paid" label-for="paid" label-cols="12">
                                        <b-input-group>
                                            <b-form-input type="text" v-model="paid" placeholder="Paid" size="sm"
                                                :disabled="false"></b-form-input>
                                            <b-input-group-append>
                                                <b-button size="sm" :disabled="false" variant="outline-secondary"
                                                    @click="paid = '0.00'">
                                                    <i class="fa fa-remove"></i>
                                                </b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" sm="6" md="4" xl="3">
                                    <b-form-group label="Due" label-for="due" label-cols="12">
                                        <b-input-group>

                                            <b-form-input type="text" :value="parseFloat(matches.selected.reduce((sum, item) => (sum + parseFloat(item.due)), 0)).toLocaleString(undefined, {
                                                minimumFractionDigits: 2
                                            })" placeholder="Due" size="sm" :disabled="true"></b-form-input>
                                            <b-input-group-append>
                                                <b-button size="sm" :disabled="true" variant="outline-secondary"
                                                    @click="matches.selected = []">
                                                    <i class="fa fa-remove"></i>
                                                </b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
                            </b-row>

                            <b-row>
                                <b-col>
                                    <d-table classdivtable="availtable datatable nested footertotal_danger"
                                        refid="matches" :icon="matches.icon" :busy="matches.busy" :tools="matches.tools"
                                        :badges="matches.badges" :fields="matches.fields" :selectall="matches.selectall"
                                        :items="matches.items" :page="matches.page" :downloaded="matches.downloaded"
                                        :showpages="false" @load="matches_load" @click="matches_click"
                                        @select="matches_select">
                                    </d-table>
                                    <div v-if="component">
                                        <component :is="component" :selection="matches.selected" :config="cconfig"
                                            @discard="matches_click('discard')" @refresh="matches_click('refresh')">
                                        </component>
                                    </div>
                                </b-col>
                            </b-row>

                        </b-tab>
                    </b-tabs>

                </b-card-body>
                <!-- </b-overlay> -->
                <b-card-footer class="nopadding mt-2">
                    <b-row no-gutters>
                        <b-col cols="4"></b-col>
                        <b-col class="text-right" cols="8">
                            <b-button squared size="sm" variant="secondary" @click="discard">
                                <i class="fa fa-chevron-left pr-1"></i>
                                Back
                            </b-button>
                        </b-col>
                    </b-row>

                </b-card-footer>
            </b-card>
        </div>
    </b-card>

</template>

<script>
import gql from "graphql-tag";

export default {
    name: "SLMatch",
    async mounted() {
        await this.accessdenied();
    },
    data() {
        return {
            tabindex: 0,
            busy: false,
            readonly: false,
            multiple: false,
            paid: "0.00",
            referenceno: [],
            slac: [],
            eventcode: [],
            item: {
                message: "",
                error: true,
                transactiono: "",
                yourref: ""
            },
            postit_disabled: true,
            matches: {
                icon: "fa fa-list text-danger",
                debounce: 500,
                busy: false,
                selectall: false,
                tools: "go,download,clipboard",
                fields: [
                    {
                        key: "selected",
                        label: "...",
                        class: "text-center w-25px",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-right w-50px text-primary",
                    },
                    {
                        key: "slac",
                        label: "SL A/C",
                        sortable: true,
                        class: "d-none d-sm-table-cell",
                    },
                     {
                        key: "date_at",
                        label: "Date",
                        sortable: true,
                        class: "text-right",
                         formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = this.$moment
                                    .unix(value / 1000)
                                    .utc(true)
                                    .format("DD/MM/YY HH:mm");
                            }
                            return result;
                        },
                    },
                    {
                        key: "referenceno",
                        label: "ReferenceNo",
                        sortable: true,
                        class: "text-right",
                    },
                    // {
                    //     key: "ticketno",
                    //     label: "TicketNo",
                    //     sortable: true,
                    //     class: "d-none d-sm-table-cell",
                    //     formatter: (value, key, item) => {
                    //         let result = value;
                    //         if (result) {
                    //             if (result.length > 10) {
                    //                 result = result.slice(0, 12) + "...";
                    //             }
                    //         }
                    //         return result;
                    //     },
                    // },
                    {
                        key: "slac",
                        label: "SL A/C",
                        sortable: true,
                        class: "d-none d-sm-table-cell",
                    },
                    {
                        key: "eventcode",
                        label: "Eventcode",
                        sortable: true,
                        class: "d-none d-sm-table-cell",
                    },
                    {
                        key: "amount",
                        label: "Amount",
                        sortable: true,
                        class: "text-right",
                        total: 0,
                        totalled: true,
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = parseFloat(value).toLocaleString(undefined, {
                                    minimumFractionDigits: 2
                                })
                            }
                            return result;
                        },
                    },
                    {
                        key: "due",
                        label: "Due",
                        sortable: true,
                        class: "text-right",
                        total: 0,
                        totalled: true,
                         formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = parseFloat(value).toLocaleString(undefined, {
                                    minimumFractionDigits: 2
                                })
                            }
                            return result;
                        },
                    },
                    {
                        key: "pay",
                        label: "Part Pay",
                        sortable: true,
                        class: "text-right",
                        total: 0,
                        totalled: true,
                         formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = parseFloat(value).toLocaleString(undefined, {
                                    minimumFractionDigits: 2
                                })
                            }
                            return result;
                        },
                    },
                ],
                badges: [],
                item: {},
                items: [],
                selected: [],
                downloaded: [],
            },
        };
    },
    watch: {
        referenceno: {
            async handler(newVal, oldVal) {
                //this.matches.items = []
                this.item.yourref = ""
                this.item.message = ""
                this.item.error = true
                this.postit_disabled = true
            }
        },
        "matches.selected": {
            async handler(newVal, oldVal) {
                if (this.matches.selected.map(item => item.referenceno).length > 0) {
                    this.referenceno = this.matches.selected.map(item => item.referenceno)
                }
                // this.referenceno = this.matches.selected.map(item => item.referenceno)
            }
        },
        // async slac() {
        //     if (this.slac.length > 0) {
        //         await this.matches_load();
        //     }
        // },
        async slac() {
            if (this.slac.length > 0) {
                await this.matches_load();
            } else {
                this.matches.items = []
            }
        },
        async eventcode() {
            await this.matches_load();
        },
    },
    methods: {
        async accessdenied() {

        },
        async matches_load(offset, limit, page) {

            let state = this.matches;

            this.busy = true
            if (page) {
                state.page = page
            }

            state.busy = true;

            let variables = {
                referenceno: this.referenceno.length > 0 ? this.referenceno.join(",") : null,
                slac: this.slac.length > 0 ? this.slac.join(",") : null,
                eventcode: this.eventcode.length > 0 ? this.eventcode.join(",") : null,
                multiple: this.multiple == "true" ? true : false,
                action: "match"
            };
            console.log("variables", variables);
            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query SL_matches($referenceno: String, $slac: String,$eventcode: String, $action: String, $multiple: Boolean) {
                            SL_matches(referenceno: $referenceno,slac: $slac,eventcode: $eventcode, action: $action, multiple:$multiple) {
                                message
                                error
                                transactionno
                                yourref
                                remittances {
                                    counter
                                    entry
                                    date_at
                                    blac
                                    referenceno
                                    ticketno
                                    slac
                                    eventcode
                                    amount
                                    due
                                    pay
                                }
                            }
                        }
                    `,
                    variables,
                });

                state.downloaded = []
                if (limit == 0) {
                    state.downloaded = response.data.SL_matches
                } else {
                    state.items = []
                    state.items = response.data.SL_matches;

                    this.item = response.data.SL_matches
                    this.matches.items = this.item.remittances
                    this.postit_disabled = this.item.error
                }



            } catch (error) {
                console.log(error);
            }

            this.matches.busy = false;
            this.busy = false
        },
        async matches_click(a, ss) {
            console.log("matches_click", a, ss);

            let state = this.matches;

            switch (a) {
                case "selectall":
                    this.matches.selectall = !this.matches.selectall;
                    break;

                case "download_view":
                    state.downloaded = []
                    state.downloaded = this.state.items
                    break;

                case "download_all":
                    state.downloaded = []
                    await this.matches_load(0, 0);
                    break;


                case "go":
                    this.component = null;
                    await this.matches_load();
                    break;

                case "save":
                    await this.matches_saveit()
                    break;

            }
        },
        async matches_select(ss, tools) {

            let state = this.matches;

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = ["back", "go", "filter", "download", "add", "export", "clipboard"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false;
                    }
                });
                // == 1
                enabled = ["edit", "notes"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length == 1 ? false : true;
                    }
                });
                // > 1
                enabled = ["save", "deleteconfirm"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length > 0 ? false : true;
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });
            }

            if (state.selected.length > 0) {
                state.item = { ...state.selected[0] }  // WHAT YOU SELECTED
                state.item.datetravel = this.$moment.unix(state.item.datetravel * 0.001).utc(true).format("YYYY-MM-DD")
                state.item.ticketno = state.item.ticketno.split(',')
            } else {
                state.item = {}
            }
        },
        async matches_save() {

            this.busy = true

            let variables = {
                referenceno: this.referenceno.length > 0 ? this.referenceno.join(",") : null,
                slac: this.slac.length > 0 ? this.slac.join(",") : null,
                eventcode: this.eventcode.length > 0 ? this.eventcode.join(",") : null,
                yourref: this.item.yourref ? this.item.yourref : null,
                action: "match",
                multiple: this.multiple == "true" ? true : false,
                remittances: this.cleanit(this.matches.items),
                apply: true
            };
            console.log("variables", variables);
            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query SL_matches($referenceno: String, $slac: String, $yourref:String, $eventcode: String, $action:String, $remittances:[SL_remittances_input], $multiple: Boolean, $apply:Boolean) {
                            SL_matches(referenceno: $referenceno, slac: $slac, yourref:$yourref, eventcode:$eventcode, action:$action, remittances:$remittances, multiple:$multiple, apply:$apply ) {
                                message
                                error
                                transactionno
                                yourref	
                                remittances {
                                    counter
                                    entry
                                    date_at
                                    blac
                                    referenceno
                                    ticketno
                                    slac
                                    eventcode
                                    amount
                                    due
                                    pay
                                }
                            }
                        }
                    `,
                    variables,
                });

                this.item = response.data.SL_matches
                // this.matches.items = this.item.remittances

                this.postit_disabled = true

            } catch (error) {
                console.log(error);
            }

            this.busy = false
        },
    },
};
</script>